(function e(t, n, r) {
  function s(o, u) {
    if (!n[o]) {
      if (!t[o]) {
        var a = typeof require == "function" && require;
        if (!u && a)return a(o, !0);
        if (i)return i(o, !0);
        var f = new Error("Cannot find module '" + o + "'");
        throw f.code = "MODULE_NOT_FOUND", f
      }
      var l = n[o] = {exports: {}};
      t[o][0].call(l.exports, function (e) {
        var n = t[o][1][e];
        return s(n ? n : e)
      }, l, l.exports, e, t, n, r)
    }
    return n[o].exports
  }

  var i = typeof require == "function" && require;
  for (var o = 0; o < r.length; o++)s(r[o]);
  return s
})({
  1: [function (require, module, exports) {
    "use strict";
    !function () {
      var e = function () {
        var e = document.querySelector(".esri-sub-nav"), s = document.querySelector(".esri-sub-nav .esri-sub-nav-heading");
        s.addEventListener("click", function (s) {
          s.preventDefault(), e.classList.toggle("is-expanded")
        });
        var t = document.querySelector(".esri-sub-nav-item.is-drop-down"), i = [].slice.call(document.querySelectorAll(".esri-sub-nav-item .sub-items li")).length;
        if (null !== document.querySelector(".esri-sub-nav-item .sub-items li")) {
          var n = document.querySelector(".esri-sub-nav-item .sub-items li").clientHeight;
          t.addEventListener("click", function (e) {
            t.classList.toggle("is-expanded"), document.querySelector(".esri-sub-nav-item.is-drop-down").classList.contains("is-expanded") ? document.querySelector(".esri-sub-nav-item ul").style.height = n * i + 1 + "px" : document.querySelector(".esri-sub-nav-item ul").style.height = "0px", window.addEventListener("click", function (e) {
              document.querySelector(".esri-sub-nav-item.is-drop-down").classList.contains("is-expanded") && e.screenX - document.querySelector(".esri-sub-nav-item.is-drop-down").offsetLeft < 0 && (t.classList.remove("is-expanded"), document.querySelector(".esri-sub-nav-item ul").style.height = "0px")
            })
          })
        }
        window.addEventListener("scroll", function () {
          window.pageYOffset >= e.offsetTop && document.querySelector(".esri-sub-nav-wrapper").classList.add("is-sticky"), window.pageYOffset <= 0 && document.querySelector(".esri-sub-nav-wrapper").classList.remove("is-sticky")
        })
      };
      e()
    }(void 0);

  }, {}]
}, {}, [1])
//# sourceMappingURL=esriSubNav.js.map
